import { Empty, type EmptyProps } from "antd";
import clsx from "clsx";
import "./BEmpty.scss";

const BEmpty = ({ className, ...props }: EmptyProps) => (
  <Empty className={clsx("b-empty", className)} {...props} />
);

export default BEmpty;
